/**
 * QL-361 — value control for score conditional-display rules
 * (`__pa_…_score`, `__quiz_score_<id>`).
 *
 * Shared by the flow editor and the three PDF condition dialogs: a plain
 * number input, with the pass score beside it as a hint so the designer knows
 * what scale the points are on. The rule value stays a string, like every
 * other rule value; the evaluators compare it numerically. A number input
 * only ever yields a numeric string or "", and every dialog already refuses an
 * empty value, so no separate "is it a number" check is needed on save.
 */

export const T = {
  en_GB: {
    placeholder: "Enter points",
    passScoreHint: (points: string) => `Pass score: ${points} points`,
  },
  nb_NO: {
    placeholder: "Angi poeng",
    passScoreHint: (points: string) => `Bestått-grense: ${points} poeng`,
  },
} as const;
